import axios from "axios";
import API from "../_helpers/endpointService";

export const getprojectdwprdocinfo = (data, id) => {
  let apiUrl = API.DWPR_LISTVIEW + "?projectId=" + id + "&Activity=" + data.Activity + "&FromDate=" + data.FromDate + "&ToDaTe=" + data.ToDaTe + '&PageNumber=' + data.PageNo + '&PageSize=' + data.PageSize;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "DWPRLIST_DOCS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const geteditdwprdocinfo = (id) => {
  let apiUrl = API.DWPR_LISTVIEW + '/id?id=' + id;
  return (dispatch) => {
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "DWPREDIT_DOCS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const dwprlookupactivities = () => {
  let apiUrl = API.LOOKUP_ACTDWPR;
  return (dispatch) => {
    axios({
      method: "get",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "LOOKUP_DWPRDESC", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const adddwprdocinfo = (data, formData) => {
  let apiUrl = API.DWPR_LISTVIEW;
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch(adduploaddwprdocinfo(formData, response.data))
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const adduploaddwprdocinfo = (data, id) => {
  let apiUrl = API.DWPR_LISTVIEW + '/' + id;
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const dwprlookupdescription = () => {
  let apiUrl = API.LOOKUP_DESCDWPR;
  return (dispatch) => {
    axios({
      method: "get",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "LOOKUP_DWPRDESC", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const deletemulitidwprdocs = (data, modify) => {
  let ids = "";
  if (data && data.length > 0) {
    data.map((val, index) => {
      if (index == 0) {
        ids += "ids=" + val.data;
      }
      else {
        ids += "&ids=" + val.data;
      }
    })
  }
  let apiUrl = API.DWPR_LISTVIEW + '/id?' + ids + '&modify=' + modify;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "DELETE",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};
export const deletedwprdocs = (data, modify) => {
  let apiUrl = API.DWPR_LISTVIEW + '/id?ids=' + data + '&modify=' + modify;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "DELETE",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};
export const filedeletedwpr = (id, name) => {
  let apiUrl = API.DWPR_LISTVIEW + '/' + id + '?filename=' + name;
  return (dispatch) => {
    axios({
      method: "DELETE",
      url: apiUrl,
      // data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const putdwprdocinfo = (data, formData, id, array) => {
  let apiUrl = API.DWPR_LISTVIEW + '/' + id;
  return (dispatch) => {
    axios({
      method: "PUT",
      url: apiUrl,
      data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        if (response?.status === 200) {
          if (array.length > 0) {
            dispatch(adduploaddwprdocinfo(formData, id))
          }
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const gethistorylogdwprdocinfo = (id) => {
  let apiUrl = API.HISTORY_LOG + id + '?name=DailyProgress'
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
      // data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "HISTORY_LOG", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};
